import {
  FaDatabase,
  FaGlobeAsia,
  FaServer,
} from "@onemind-services-llc/react-icons-ng/fa";
import { IoTerminalOutline } from "@onemind-services-llc/react-icons-ng/io5";
import { PiNewspaperClippingLight } from "@onemind-services-llc/react-icons-ng/pi";
import HeroBg from "public/marketplace-apps/hero/Hero-section-mongodb.png";

export const MONGO_DB_CONSTANTS = {
  HERO: {
    title: "OneMind Services — MongoDB® Community Edition (One-Click App) ",
    desc: "Easily deploy MongoDB, a popular NoSQL database known for its flexibility, scalability, and developer-friendly JSON-based storage model.",
    button: {
      label: "Deploy Now",
      link: "contact-us",
    },
    image: HeroBg,
  },
  INTRO: {
    title: "General Information",
    text: "MongoDB® is a high-performance, scalable, document-oriented NoSQL database system finely tuned for managing large datasets. With JSON-based data storage and dynamic schemas, it supports all major programming languages. It's utilized globally for a variety of applications—ranging from geo-based and graph search to full-text processing—and fits seamlessly within modern stacks like MEAN. ",
  },
  WHY_ONEMIND: {
    title: "Deploy with OneMind Ease ",
    desc: [
      {
        highlight: "",
        text: "Experience frictionless deployment of MongoDB® Community Edition through our One-MindEase—zero-touch, one-click setup on your preferred cloud platform. We handle the infrastructure provisioning and secure your instance out-of-the-box so you can build immediately.",
      },
    ],
    marginTop: 0,
    btnText: "Start Now",
  },
  GET_STARTED: {
    title: "Getting Started: Access Your Instance ",
    desc: [
      {
        text: "Upon successful deployment, OneMind will provide you with: ",
      },
      {
        text: "Mongo Admin Username :",
        highlight: "mongoadmin",
      },
      {
        text: "Mongo Admin Password :",
        highlight: "<your-generated-password>",
      },
    ],
    connection: {
      text: "To connect:",
      command:
        'mongosh "mongodb://mongoadmin:@<your-generated-password>:27017/defaultdb" --authenticationDatabase admin',
    },
    note: "Note: (Replace <YOUR_INSTANCE_IP> appropriately and substitute the placeholder password.) ",
  },
  CONNECTION: {
    title: "Connect via GUI or CLI ",
    desc: "Choose your management interface: ",
    list: [
      {
        icon: IoTerminalOutline,
        title: "MongoDB Shell (mongosh)",
        content: "A powerful CLI tool for scripting, queries, and administration. ",
      },
      {
        icon: PiNewspaperClippingLight,
        title: "MongoDB Compass",
        content:
          "A polished GUI that simplifies data navigation, schema visualization, and query construction",
      },
    ],
    conclusion:
      "Both tools can be easily installed locally and configured using the credentials issued at deployment. ",
  },
  FEATURES: {
    items: [
      {
        icon: FaDatabase,
        title: "Auto Backups",
        text: "Optional backups ensure data resilience (recommended).",
      },
      {
        icon: FaGlobeAsia,
        title: "Global Regions",
        text: "Deploy close to your user base via OneMind’s multiple data centers.",
      },
      {
        icon: FaServer,
        title: "Configurable Infrastructure",
        text: "Scale RAM, CPU, storage, and add networking features like private IP, DDoS protection, and user-data bootstrapping.",
      },
    ],
    columns: { base: 1, sm: 2, md: 3 },
  },
  BENEFITS: {
    title: "Advance Options",
    subTitle: "For power users: ",
    options: [
      {
        label: "Replica Sets & TLS",
        text: "Deploy high‑availability MongoDB with secure TLS, powered by Kubernetes orchestration.  ",
      },
      {
        label: "Multi-Region Clustering",
        text: "Through our Cloud Alliance, powered by Virtuozzo, enable automated, fault-tolerant clustering across geographic regions.",
      },
    ],
  },
  SUPPORT: {
    docsText: "repo: hub.docker.com/_/mongo",
    docsLink: "https://hub.docker.com/_/mongo",
  },
};
